var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"noContainer"},[_c('img',{attrs:{"src":require("@/assets/icons/icon_no_data.png")}}),_c('span',[_vm._v("没有数据~")])])
}]

export { render, staticRenderFns }